import { useMemo } from "react";

export const useTable = <
  DataType extends { disabled?: boolean; selected?: boolean },
>(
  data: DataType[],
) => {
  const isSomeSelected = useMemo(() => {
    const selected = data.filter((item) => item.selected);
    const enable = data.filter((item) => !item.disabled);
    return (
      data.some((item) => item.selected) && selected.length !== enable.length
    );
  }, [data]);

  return {
    isSomeSelected,
  };
};
